// import { SavedSearchAddedListComponent } from './components/saved-search-added-list/saved-search-added-list.component';
import { NumberToFixedPipe } from './../../modules/shared/pipes/number-tofixed.pipe';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SavedSearchesRoutingModule } from './saved-searches-routing.module';
import { SavedSearchesService } from './services/saved-searches.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContextMenuModule } from 'primeng/contextmenu';
import { SharedComponentModule } from 'src/app/modules/shared/shared.module';
import { PrimngDesignModule } from 'src/app/modules/primng-design/primng-design.module';
import { ReportsSharedModule } from 'src/app/reports/reports-shared.module';
import { SavedSearchesComponent } from './saved-searches.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CurrencySymbolPipe } from 'src/app/modules/shared/pipes/currency-symbol.pipe';
import { SavedSearchAddEditComponent } from './components/saved-search-add-edit/saved-search-add-edit.component';
import { PredictComponent } from './components/predict/predict.component';
import {SplitterModule} from 'primeng/splitter';
import { NameShortenerPipe } from 'src/app/shared/pipes/name-shortener.pipe';
// import { NgApexchartsModule } from "ng-apexcharts";
import { ListboxModule } from 'primeng/listbox';
import { ProgressBarModule } from 'primeng/progressbar';
import { PlotlyModule } from 'angular-plotly.js';
import * as PlotlyJS from 'plotly.js-dist-min';
// import { AddToListComponent } from './components/add-to-list/add-to-list.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
PlotlyModule.plotlyjs = PlotlyJS;

@NgModule({
    declarations: [
        SavedSearchesComponent,
        SavedSearchAddEditComponent,
        // PredictComponent,
        // PredictDialogComponent,
        // AddToListComponent,
        // SavedSearchAddedListComponent
    ],
    imports: [
        CommonModule,
        SavedSearchesRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        ContextMenuModule,
        SplitterModule,
        SharedComponentModule,
        PrimngDesignModule,
        ReportsSharedModule,
        // NgApexchartsModule,
        ListboxModule,
        ProgressBarModule,
        //PickerModule,
        PlotlyModule,
        ProgressSpinnerModule
    ],
    providers: [
        SavedSearchesService,
        ConfirmationService,
        MessageService,
        CurrencySymbolPipe,
        NumberToFixedPipe,
        NameShortenerPipe
    ],
    exports: []
})
export class SavedSearchesModule { }
